// Auth
export const AUTH_LOADING = "AUTH_LOADING";
export const AUTH_END_LOADING = "AUTH_END_LOADING";
export const AUTH_GET_DATA = "AUTH_GET_DATA";
export const AUTH_CLEAR = "AUTH_CLEAR";
export const AUTH_SET_DATA = "AUTH_SET_DATA";

// Paquetes
export const PACKAGE_LOADING = "PACKAGE_LOADING";
export const PACKAGE_END_LOADING = "PACKAGE_END_LOADING";
export const PACKAGE_LOADING_OPERATION = "PACKAGE_LOADING_OPERATION";
export const PACKAGE_END_LOADING_OPERATION = "PACKAGE_END_LOADING_OPERATION";
export const PACKAGE_GET_DATA = "PACKAGE_GET_DATA";
export const PACKAGE_GET_ELEMENTS = "PACKAGE_GET_ELEMENTS";
export const PACKAGE_GET_ITEM = "PACKAGE_GET_ITEM";
export const PACKAGE_CLEAR = "PACKAGE_CLEAR";
export const PACKAGE_GET_ITEM_ARTICLES = "PACKAGE_GET_ITEM_ARTICLES";
export const PACKAGE_DELETE_ELEMENT = "PACKAGE_DELETE_ELEMENT";
export const PACKAGE_UPDATE_ARTICLE_STATUS = "PACKAGE_UPDATE_ARTICLE_STATUS";
export const PACKAGE_CREATE_AND_ADD = "PACKAGE_CREATE_AND_ADD";

// Articulos
export const ARTICLE_GET_DATA = "ARTICLE_GET_DATA";
export const ARTICLE_GET_ITEM = "ARTICLE_GET_ITEM";
export const ARTICLE_LOADING = "ARTICLE_LOADING";
export const ARTICLE_END_LOADING = "ARTICLE_END_LOADING";
export const ARTICLE_LOADING_OPERATION = "ARTICLE_LOADING_OPERATION";
export const ARTICLE_END_LOADING_OPERATION = "ARTICLE_END_LOADING_OPERATION";
export const ARTICLE_CLEAR = "ARTICLE_CLEAR";
export const ARTICLE_ADD_SINGLE = "ARTICLE_ADD_SINGLE";
export const ARTICLE_UPDATE_STATUS = "ARTICLE_UPDATE_STATUS";
export const ARTICLE_UPDATE_SINGLE = "ARTICLE_UPDATE_SINGLE";
export const ARTICLE_DELETE_ELEMENT = "ARTICLE_DELETE_ELEMENT";

// Perfil
export const PROFILE_LOADING = "PROFILE_LOADING";
export const PROFILE_END_LOADING = "PROFILE_END_LOADING";
export const PROFILE_GET_DATA = "PROFILE_GET_DATA";
export const PROFILE_CLEAR = "PROFILE_CLEAR";

// Clientes
export const CLIENT_GET_DATA = "CLIENT_GET_DATA";
export const CLIENT_GET_ELEMENTS = "CLIENT_GET_ELEMENTS";
export const CLIENT_LOADING = "CLIENT_LOADING";
export const CLIENT_END_LOADING = "CLIENT_END_LOADING";
export const CLIENT_ADD_SINGLE = "CLIENT_ADD_SINGLE";
export const CLIENT_UPDATE_SINGLE = "CLIENT_UPDATE_SINGLE";
export const CLIENT_REMOVE_SINGLE = "CLIENT_REMOVE_SINGLE";
export const CLIENT_GET_SINGLE = "CLIENT_GET_SINGLE";
export const CLIENT_LOADING_OPERATION = "CLIENT_LOADING_OPERATION";
export const CLIENT_END_LOADING_OPERATION = "CLIENT_END_LOADING_OPERATION";
export const CLIENT_CLEAR = "CLIENT_CLEAR";

// Usuarios
export const USER_GET_DATA = "USER_GET_DATA";
export const USER_LOADING = "USER_LOADING";
export const USER_END_LOADING = "USER_END_LOADING";
export const USER_GET_SINGLE = "USER_GET_SINGLE";
export const USER_LOADING_OPERATION = "USER_LOADING_OPERATION";
export const USER_END_LOADING_OPERATION = "USER_END_LOADING_OPERATION";
export const USER_ADD_SINGLE = "USER_ADD_SINGLE";
export const USER_UPDATE_SINGLE = "USER_UPDATE_SINGLE";
export const USER_REMOVE_SINGLE = "USER_REMOVE_SINGLE";
export const USER_CLEAR = "USER_CLEAR";

// Errores
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
